import { render, staticRenderFns } from "./VentanaBorrarTerminal.vue?vue&type=template&id=52ab41cc&scoped=true&slot-scope=scope&"
import script from "./VentanaBorrarTerminal.vue?vue&type=script&lang=js&"
export * from "./VentanaBorrarTerminal.vue?vue&type=script&lang=js&"
import style0 from "./VentanaBorrarTerminal.vue?vue&type=style&index=0&id=52ab41cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab41cc",
  null
  
)

export default component.exports